interface DealerHoursProps {
  hoursData: Record<string, string>;
  now?: Date;
}

export interface DealerDayHours {
  isOpen: boolean | null;
  isClosed: boolean | null;
  open: string | null;
  close: string | null;
}

export enum DaysOfWeek {
  Sun = 'Sun',
  Mon = 'Mon',
  Tue = 'Tue',
  Wed = 'Wed',
  Thu = 'Thu',
  Fri = 'Fri',
  Sat = 'Sat',
}

export const DayOrder = [
  DaysOfWeek.Sun,
  DaysOfWeek.Mon,
  DaysOfWeek.Tue,
  DaysOfWeek.Wed,
  DaysOfWeek.Thu,
  DaysOfWeek.Fri,
  DaysOfWeek.Sat,
];

type Schedule = {
  [key in DaysOfWeek]: DealerDayHours;
};

export type DealerHours = {
  isOpenToday: boolean;
  todayHours: {
    open: string | null;
    close: string | null;
  };
  hours: Schedule;
};

function createDealerDayHours(hoursString: string): DealerDayHours {
  const isClosed = hoursString ? hoursString.toLowerCase() === 'closed' : null;
  const [open, close] = !isClosed && hoursString ? hoursString.split(' - ') : [null, null];

  return {
    isOpen: isClosed === null ? null : !isClosed,
    isClosed,
    open,
    close,
  };
}

export default function createDealerHours({
  hoursData,
  now = new Date(),
}: DealerHoursProps): DealerHours {
  const dayHours = Object.fromEntries(
    Object.entries(hoursData).map(([key, hoursString]) => [key, createDealerDayHours(hoursString)])
  ) as Schedule;
  const todayDayHour = dayHours[DayOrder[now.getDay()]];
  const isOpenToday = !todayDayHour.isClosed;

  return {
    isOpenToday,
    todayHours: {
      open: todayDayHour.open,
      close: todayDayHour.close,
    },
    hours: dayHours,
  };
}
